/**
 * The slash commands both Benny composers offer (Benny UX pass 3, P3-10):
 * one list so the docked chat and Conversations can never drift apart. Every
 * command is a COMPOSER action; `help` is the one that sends a message, and
 * both surfaces send the same one. Personal accounts: adapted.
 */
export const SLASH_COMMANDS = [
  {
    id: 'plan',
    label: 'Plan multiple actions',
    hint: 'Review every step before anything runs',
  },
  {
    id: 'open',
    label: 'Open a page',
    hint: 'On the canvas, or jump straight to it',
  },
  { id: 'attach', label: 'Attach files', hint: 'Images and documents' },
  {
    id: 'help',
    label: 'What can you do?',
    hint: "List what Benny can help with here",
  },
  {
    id: 'new',
    label: 'New conversation',
    hint: 'Start a fresh thread with Benny',
  },
] as const

export type SlashCommandId = (typeof SLASH_COMMANDS)[number]['id']

/** What `/plan` puts in the composer: the prefix the planner routes on. */
export const PLAN_PREFILL = 'Plan: '

/** What `/help` sends, on both surfaces. */
export const HELP_ASK = 'What can you do?'

/** True when a message is a plan request ("Plan: …", any case). */
export const isPlanRequest = (message: string): boolean =>
  /^plan:\s*/i.test(message.trim())

/** The instruction behind a plan request, without the prefix. */
export const planInstruction = (message: string): string =>
  message.trim().replace(/^plan:\s*/i, '').trim()
